<template>
  <div>
    <div class="pcMenu">
      <div class="d-none d-sm-block menuList">
        <div v-if="currentLanguage==0">
          <div class="menu">
            <div class="logo">
              <img src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/webLogoEN.png" @click="btn('/?source=webtable')">
            </div>
            <div class="menu-container" @mouseleave="hideSubmenu">
              <div class="menu-item" @mouseenter="showSubmenu(1)" :class="{active:index==1}">
                <div class="menu_name">
                  Who We Are
                </div>
                <transition name="fade" v-if="index==1&&submenuVisible==true">
                  <div class="submenu">
                    <div class="submenuBox">
                      <div class="submenu-item" @click="btn('/aboutUs?source=webtable')">About Us</div>
                      <div class="submenu-item" @click="btn('/team?source=webtable')">Our Team</div>
                    </div>
                    <div class="submenuBox">
                      <div class="submenu-item" @click="btn('/asia?source=webtable')">Asia Access</div>
                      <div class="submenu-item" @click="btn('/media?source=webtable')">News & Events</div>
                    </div>

                  </div>
                </transition>
              </div>
              <div class="menu-item" @mouseenter="showSubmenu(2)" :class="{active:index==2}">
                <div class="menu_name">
                  Online Services
                </div>
                <transition name="fade" v-if="index==2&&submenuVisible==true">
                  <div class="submenu">
                    <div class="submenuBox">
                      <div class="submenu-item" @click="btn('/toolbox?source=webtable','eQuote');toguid('/toolbox?source=webtable','eQuote')">eQuote</div>
                      <div class="submenu-item" @click="toguid('/toolbox?source=webtable','HoldenAnswer');btn('/toolbox?source=webtable','HoldenAnswer');">Holden Answer</div>
                    </div>
                    <div class="submenuBox">
                      <div class="submenu-item" @click="toguid('/toolbox?source=webtable','API');btn('/toolbox?source=webtable','API')">API</div>
                      <div class="submenu-item" @click="toguid('/toolbox?source=webtable','SurveyPanda');btn('/toolbox?source=webtable','SurveyPanda')">SurveyPanda</div>
                    </div>
                  </div>
                </transition>
              </div>
              <div class="menu-item" @mouseenter="showSubmenu(3)" :class="{active:index==3}">
                <div class="menu_name">
                  Solutions
                </div>
                <transition name="fade" v-if="index==3&&submenuVisible==true">
                  <div class="submenu">
                    <div class="submenuBox">
                      <div class="submenu-item" @click="btn('/TreatmentSynopsis?source=webtable','SyndicatedInsights');toguid('/TreatmentSynopsis?source=webtable','SyndicatedInsights')">Syndicated Insights</div>
                      <div class="submenu-item" @click="toguid('/TreatmentSynopsis?source=webtable','Treatment');btn('/TreatmentSynopsis?source=webtable','Treatment');">Treatment Synopsis</div>
                      <div class="submenu-item" @click="toguid('/TreatmentSynopsis?source=webtable','Report');btn('/TreatmentSynopsis?source=webtable','Report');">Patient Journeys Report</div>

                    </div>
                    <div class="submenuBox">
                      <div class="submenu-item" @click="btn('/qual?source=webtable')">Qualitative</div>
                      <div class="submenu-item" @click="btn('/quant?source=webtable')">Quantitative</div>
                    </div>
                    <div class="submenuBox">
                      <div class="submenu-item" @click="btn('/industry?source=webtable')">Industry Expertise</div>
                      <div class="submenu-item" @click="btn('/specialist?source=webtable')">Specialist Solutions</div>
                    </div>
                  </div>
                </transition>
              </div>
              <div class="menu-item" @mouseenter="showSubmenu(4)" :class="{active:index==4}">
                <div class="menu_name">
                  Resources
                </div>
                <transition name="fade" v-if="index==4&&submenuVisible==true">
                  <div class="submenu">
                    <div class="submenuBox">
                      <div class="submenu-item" @click="btn('/physicians?source=webtable')">Physician Panel</div>
                      <div class="submenu-item" @click="btn('/patients?source=webtable')">Patient Panel</div>
                      <div class="submenu-item" @click="btn('/consumer?source=webtable')">Consumer Panel</div>

                    </div>
                    <div class="submenuBox">
                      <div class="submenu-item" @click="btn('/media?source=webtable&type=White Paper&id=7')">White Paper & Case Study</div>
                      <div class="submenu-item" @click="btn('/webinar?source=webtable')">Webinars</div>
                      <div class="submenu-item" @click="btn('/glossary?source=webtable')">Glossary</div>

                    </div>
                  </div>
                </transition>
              </div>
              <div class="menu-item" @mouseenter="showSubmenu(5)" :class="{active:index==5}">
                <div class="menu_name" @click="btn('/contact?source=webtable')">
                  Contact
                </div>

              </div>
              <div class="menu-item" @mouseenter="showSubmenu(6)">
                <div class="menu_name" @click="btn('/equote?source=webtable')">
                  <img src="@/assets/img/equote.png" alt="">
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <!-- 手机端导航栏 -->

    <div class="mobile d-block d-sm-none">
      <!-- 英文菜单 -->
      <div v-if="currentLanguage==0">
        <b-navbar toggleable="lg" type="light" variant="light" fixed="top">
          <b-navbar-brand>
            <img src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/webLogoEN.png" @click.stop="btn('/?source=webtable')">
            <span class="mobilelanguage">
              <span @click="changeLanguage(1)">中文 | </span>
              <span @click="changeLanguage(0)">EN</span>
            </span>

          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse" style="margin-right:10px" id="toggle" />
          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <!-- 总菜单 -->
            <b-navbar-nav class="ml-auto" style="padding:10px">

              <el-collapse>
                <el-collapse-item title="Who We Are" name="1" style="padding: 15px 20px;">
                  <div @click="mobileBtn('/aboutUs?source=webtable')">- About Us</div>
                  <div @click="mobileBtn('/team?source=webtable')">- Our Team</div>
                  <div @click="mobileBtn('/asia?source=webtable')">- Asia Access</div>
                  <div @click="mobileBtn('/media?source=webtable')">- News & Events</div>
                </el-collapse-item>
                <!-- <el-collapse-item title="Panels" name="2-1" style="padding: 15px 20px">
                  <div @click="mobileBtn('/physicians?source=webtable')">- Physician Panel</div>
                  <div @click="mobileBtn('/patients?source=webtable')">- Patient Panel</div>
                  <div @click="mobileBtn('/consumer?source=webtable')">- Consumer Panel</div>
                </el-collapse-item> -->
                <el-collapse-item title="Online Services" name="2" style="padding: 15px 20px">

                  <div @click="mobileBtn('/toolbox?source=webtable','eQuote');toguid('/toolbox?source=webtable','eQuote')">- eQuote</div>
                  <div @click="toguid('/toolbox?source=webtable','HoldenAnswer');mobileBtn('/toolbox?source=webtable','HoldenAnswer');">- Holden Answer</div>
                  <div @click="toguid('/toolbox?source=webtable','API');mobileBtn('/toolbox?source=webtable','API');">- API</div>
                  <div @click="toguid('/toolbox?source=webtable','SurveyPanda');mobileBtn('/toolbox?source=webtable','SurveyPanda');">- SurveyPanda</div>
                </el-collapse-item>
                <el-collapse-item title="Solutions" name="3" style="padding:15px 20px">
                  <div @click="btn('/TreatmentSynopsis?source=webtable','SyndicatedInsights');mobileBtn('/TreatmentSynopsis?source=webtable','SyndicatedInsights')">- Syndicated Insights</div>
                  <div @click="btn('/TreatmentSynopsis?source=webtable','Treatment');mobileBtn('/TreatmentSynopsis?source=webtable','Treatment')">- Treatment Synopsis</div>
                  <div @click="btn('/TreatmentSynopsis?source=webtable','Report');mobileBtn('/TreatmentSynopsis?source=webtable','Report')">- Patient Journeys Report</div>

                  <div @click="mobileBtn('/qual?source=webtable')">- Qualitative</div>
                  <div @click="mobileBtn('/quant?source=webtable')">- Quantitative</div>
                  <div @click="mobileBtn('/industry?source=webtable')">- Industry Expertise</div>
                  <div @click="mobileBtn('/specialist?source=webtable')">- Specialist Solutions</div>

                </el-collapse-item>
                <el-collapse-item title="Resources" name="4" style="padding:15px 20px">
                  <div @click="mobileBtn('/physicians?source=webtable')">- Physician Panel</div>
                  <div @click="mobileBtn('/patients?source=webtable&type=News&id=2')">- Patient Panel</div>
                  <div @click="mobileBtn('/consumer?source=webtable&type=Event&id=5')">- Consumer Panel</div>
                  <div @click="mobileBtn('/whitePaper?source=webtable')">- White Paper & Case Study</div>
                  <div @click="mobileBtn('/webinar?source=webtable')">- Webinars</div>

                  <div @click="mobileBtn('/glossary?source=webtable')">- Glossary</div>
                  <!-- <div>- Reference Websites</div> -->

                </el-collapse-item>
                <div style="padding:15px 20px ;" class="contant" @click="mobileBtn('/contact?source=webtable')">Contact</div>
                <div style="padding:15px 20px ;" class="contant" @click="mobileBtn('/equote?source=webtable')">eQuote<span class="bate"></span></div>

              </el-collapse>
            </b-navbar-nav>
          </b-collapse>
          </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
      <!-- 中文菜单 -->
      <div v-else>
        <b-navbar toggleable="lg" type="light" variant="light" fixed="top">
          <b-navbar-brand>
            <img src="https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/webLogoEN.png" @click.stop="btn('/cn/index?source=webtable')">
            <span class="mobilelanguage">
              <span @click="changeLanguage(1)">中文 | </span>
              <span @click="changeLanguage(0)">EN</span>
            </span>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse" style="margin-right:10px" id="toggle" />
          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <!-- 总菜单 -->
            <b-navbar-nav class="ml-auto" style="padding:10px">

              <el-collapse>
                <el-collapse-item title="公司" name="1" style="padding: 15px 20px;">
                  <div @click="mobileBtn('/cn/aboutUs?source=webtable')">- 关于我们</div>
                  <div @click="mobileBtn('/cn/team?source=webtable')">- 我们的团队</div>
                  <div @click="mobileBtn('/cn/asia?source=webtable')">- 链接亚洲</div>
                  <div @click="mobileBtn('/cn/media?source=webtable')">- 新闻</div>
                </el-collapse-item>
                <!-- <el-collapse-item title="资源库" name="2-1" style="padding: 15px 20px">
                  <div @click="mobileBtn('/cn/physicians?source=webtable')">- 医生资源库</div>
                  <div @click="mobileBtn('/cn/patients?source=webtable')">- 患者资源库</div>
                  <div @click="mobileBtn('/cn/consumer?source=webtable')">- 消费者资源库</div>
                </el-collapse-item> -->
                <el-collapse-item title="产品" name="2" style="padding: 15px 20px">

                  <el-collapse-item title="在线工具箱" name="2-2" style="padding:15px 20px">
                    <div @click="mobileBtn('/cn/equote?source=product')">- eQuote</div>
                    <div @click="mobileBtn('/cn/toolbox?source=webtable&product=2')">- Holden Answer</div>
                    <div @click="mobileBtn('/cn/toolbox?source=webtable&product=3')">- API</div>
                    <div @click="mobileBtn('/cn/toolbox?source=webtable&product=5')">- SurveyPanda</div>
                  </el-collapse-item>
                </el-collapse-item>
                <el-collapse-item title="解决方案" name="3" style="padding:15px 20px">
                  <div @click="mobileBtn('/cn/qual?source=webtable')">- 定性</div>
                  <div @click="mobileBtn('/cn/quant?source=webtable')">- 定量</div>
                  <div @click="mobileBtn('/cn/industry?source=webtable')">- 行业专长</div>
                  <div @click="mobileBtn('/cn/specialist?source=webtable')">- 专业解决方案</div>

                </el-collapse-item>
                <el-collapse-item title="资源" name="4" style="padding:15px 20px">
                  <el-collapse-item title="资源" name="4-1" style="padding:15px 20px">
                    <div @click="mobileBtn('/cn/glossary?source=webtable')">- 词汇表</div>
                    <!-- <div>- Reference Websites</div> -->
                    <div @click="mobileBtn('/cn/whitePaper?source=webtable')">- 白皮书和案例研究</div>
                    <div @click="mobileBtn('/cn/panel?source=webtable')">- 亚洲 Panels</div>
                  </el-collapse-item>
                  <el-collapse-item title="新闻事件" name="4-2" style="padding:15px 20px">
                    <div @click="mobileBtn('/cn/reNews?source=webtable')">- 新闻</div>
                    <div @click="mobileBtn('/cn/webinar?source=webtable')">- 网络研讨会和注册</div>
                    <div @click="mobileBtn('/cn/events?source=webtable')">- 事件</div>
                  </el-collapse-item>
                </el-collapse-item>
                <div style="padding:15px 20px ;" class="contant" @click="mobileBtn('/cn/contact?source=webtable')">联系</div>
                <div style="padding:15px 20px ;" class="contant" @click="mobileBtn('/cn/equote?source=webtable')">eQuote<span class="bate"></span></div>

              </el-collapse>
            </b-navbar-nav>
          </b-collapse>
          </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <span>Are you sure you want to log out</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">No</el-button>
        <el-button type="primary" @click="Logout()">Yes</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script >
// import {checkIsIE} from '@/utils/common.js';
// import '@/config/rem'

export default {
  data() {
    return {
      submenuVisible: false,
      index: 0,
      isShow: false,
      isShow1: false,
      open: false,
      openlist: false,
      numlist: "",
      num: "",
      option: [{ text: "- physicians" }, { text: "- Patient" }, { text: "- Consumer" }],
      option1: [{ text: "- eCommunity" }, { text: "- Patient" }, { text: "- Consumer" }],
      logincookies: false,
      dialogVisible: false,
      currentLanguage: 1,
      fullPath: ""

      // company的菜单
      // testList: [{ value: "- About Us" }, { value: "- What we do" }, { value: "- Leadership" }, { value: "- Asia Coverage" }, { value: "- News" }]
    };
  },
  mounted() {
    // this.currentLanguage=localStorage.getItem("language")
    // this.$nextTick(function () {
    //     //滚动监听事件
    //     window.addEventListener('scroll', this.btn)
    // });
  },
  computed: {
    // currentLanguage() {
    //     return Number(localStorage.getItem("language"));
    //   }
  },
  watch: {
    // $route: {
    //   handler: function(route) {
    //     // console.log(route.fullPath);
    //     this.fullPath = route.fullPath;
    //   },
    //   immediate: true
    // }
  },
  created() {
    // this.url();
    this.currentLanguage = localStorage.getItem("language");
  },
  destroyed() {
    // window.removeEventListener('scroll', this.btn)
  },
  methods: {
    log(index) {
      console.log(index);
    },
    showSubmenu(index) {
      this.submenuVisible = true;
      this.index = index;
    },
    hideSubmenu() {
      this.submenuVisible = false;
      this.index = 0;
    },

    url() {
      // 如果是中文的网址
      if (this.$route.path.includes("/cn")) {
        localStorage.setItem("language", 1);
        this.currentLanguage = 1;
      } else if (!this.$route.path.includes("/cn")) {
        localStorage.setItem("language", 0);
        this.currentLanguage = 0;
      }
    },
    // 切换语言
    changeLanguage(val) {
      localStorage.setItem("language", val);
      this.currentLanguage = localStorage.getItem("language");
      // 如果切换英文
      // debugger
      if (val == 0) {
        // 并且有cn

        if (this.$route.path.indexOf("/cn") > -1) {
          if (this.$route.path == "/cn/index" || this.$route.path == "/cn/activity" || this.$route.path == "/cn/activityFinished") {
            this.$router.push("/");
          } else if (this.$route.path.indexOf("newsDetail") > -1) {
            // 如果是news
            this.$router.push(this.$route.path.slice(3) + "?id=" + this.$route.query.id + "&source=changelanguage");
          } else {
            this.$router.push(this.$route.path.slice(3) + "?source=changelanguage");
          }
        }
      }
      // 如果是中文
      if (val == 1) {
        // 并且没有cn
        if (!this.$route.path.includes("/cn")) {
          if (this.$route.path.indexOf("newsDetail") > -1) {
            // 如果是news
            this.$router.push("/cn" + this.$route.path + "?id=" + this.$route.query.id + "&source=changelanguage");
          } else {
            this.$router.push("/cn" + this.$route.path + "?source=changelanguage");
          }
        }
      }
    },
    // language(){

    // },
    // 登出
    Logout() {
      localStorage.removeItem("logincookies");
      this.$router.push({ name: "equote", query: { source: "logout" } });
      this.dialogVisible = false;
    },
    close(num) {
      if (this.num == num) {
        this.num = "";
      }
    },
    isOpen(num) {
      // 如果数字一样并且打开了open，说明是打开的，这时候再按就要关闭
      if (this.num == num && this.open == true) {
        this.open = false;
      }
      // 如果不是说明是关闭的，这时候就要打开
      else {
        this.open = true;
        this.num = num;
      }
    },
    isOpenlist(num) {
      // 如果数字一样并且打开了open，说明是打开的，这时候再按就要关闭
      if (this.numlist == num && this.openlist == true) {
        this.openlist = false;
      }
      // 如果不是说明是关闭的，这时候就要打开
      else {
        this.openlist = true;
        this.numlist = num;
      }
      console.log(this.openlist, this.numlist);
    },
    show(value) {
      this.logincookies = false;
      this.index = value;

      if (localStorage.getItem("logincookies")) {
        this.logincookies = true;
      }
    },
    mouseLeave() {
      this.index = 0;
    },
    btn(path, id) {
      // 跳转页面
      this.$router.push({
        path
      });
      this.submenuVisible = false;
      this.index = 0;

      if (id) {
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
      }
      // console.log(index);
    },
    toguid(path, id) {
      var Id = id;
      localStorage.setItem("toId", Id);
      this.$router.push({ path });
      this.submenuVisible = false;
    },
    mobileBtn(path, id) {
      this.$router.push({
        path
      });
      this.open = false;
      this.openlist = false;
      this.num = "";
      this.numlist = "";
      document.getElementById("toggle").click();
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes fadeInFromTop {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.active {
  background-color: #d5eafa;
}
.pcMenu {
  background-color: #ecf2f5;
  position: fixed;
  width: 100%;
  z-index: 999;
  .menuList {
    position: relative;
    padding: 0 30px 0 120px;

    width: 100%;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    .menu-container {
      display: flex;
    }

    .menu-item {
      padding: 20px;
      .menu_name {
        font-size: 20px;
        cursor: pointer;
        img {
          width: 100px;
        }
      }

      .submenu {
        font-size: 16px;
      }
    }

    .submenu {
      position: absolute;
      top: 100%;
      left: 0;
      padding-top: 30px;
      padding-left: 39%;
      height: 200px;
      background-color: #ecf2f5;
      border-top: 3px solid #b2e1fc;

      border-radius: 4px;
      opacity: 1;
      width: 100%;
      display: flex;
      .submenuBox {
        padding-right: 80px;
      }
    }

    .submenu-item {
      margin: 10px 0;
      cursor: pointer;
    }

    /* 定义淡入淡出效果 */
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.3s ease;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
      opacity: 0;
    }
    .logo {
      width: 30%;
      padding-top: 10px;
      img {
        width: 250px;
      }
    }
  }
}
li {
  list-style: none;
}
.pc {
  .equote {
    width: 50px;
    img {
      width: 100%;
    }
  }
  padding: 0 30px 0 120px;

  // border-bottom: 1px solid #0087d7;
  // width: 100%;
  height: 80px;
  background: #f8f9fa;
  box-sizing: border-box;
  position: fixed;
  padding-top: 30px;
  // padding-bottom: 20px;
  // line-height: 1.2rem;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;

  .bgc {
    background-color: #ecf2f5;
  }
}

// 手机端样式
.mobile {
  .navbar {
    height: 100px;
    padding-top: 10px;
  }
  .navbar-nav {
    background-color: #fff;
  }

  img {
    margin-left: 80px;
    width: 250px;
  }
  .navbar {
    --bs-navbar-padding-y: 0;
  }
}
@media screen and (max-width: 576px) {
  * {
    font-size: 50px;
  }
  .van-dropdown-menu__item {
    font-size: 50px;
  }
  .mobile {
    height: 120px;
    background-color: #f8f9fa;
    .navbar {
      color: #707071;
      height: 200px;
      padding-top: 50px;
      .navbar-nav {
        // ul {
        //   li {
        //     font-size: 70px;
        //     padding: 15px;
        //   }
        // }
        // .first {
        //   font-weight: 700;
        //   font-size: 80px;
        // }
      }
      img {
        width: 500px;
      }
      .navbar-toggler {
        font-size: 50px;
      }
    }
  }
  .mobilelanguage {
    font-size: 50px;
    margin-left: 100px;
  }
}
// .active {
//   color: #0087d7;
// }
</style>
<style lang="scss" scoped>
/deep/.el-collapse {
  border: none;
  font-size: 70px;
  .el-collapse-item {
    // border-top: 10px solid #2cb1e9;
  }
  .el-collapse-item__header {
    color: #707071;

    border: none;
    font-size: 80px;
    font-weight: 700;
  }
  .el-collapse-item__content {
    padding: 0;
    margin-top: 35px;
    div {
      padding: 8px;
      font-size: 75px;
    }
  }
  .contant {
    font-size: 80px;
    font-weight: 700;
    line-height: 60px;
  }
}
</style>